module.exports = __webpack_public_path__ + "static/media/collections-motifs.428825bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections-motifs.jpg
// module id = 1145
// module chunks = 37